/* global ABTastyClickTracking */
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance')
}

function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === '[object Arguments]') return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }
        return arr2;
    }
}

switch (window.LM_CFG.page.name) {
    case 'home':
    case 'home-mt1':
    case 'home-mt2':
        (function () {
            //var pageURI = window.location.pathname

            // var ABTastyTrackingID = 429845 // Live Site ID
            var ABTastyTrackingID = 497703; // Staging (ec2) Site ID
            // var ABTastyTrackingID = '' // Local Dev Site ID

            var oldOnloadHomeMt1 = window.onload;

            window.onload = function () {
                if (typeof oldOnloadHomeMt1 === 'function') {
                    oldOnloadHomeMt1();
                }

                var abTastyStepTracker = function abTastyStepTracker() {
                    var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNIDENTIFIED';
                    var trackingID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ABTastyTrackingID;
                    var goal_name = /*pageURI + '-' +*/ step;

                    if (!trackingID) {
                        return false;
                    }

                    window.debugLog('ABTT Running:', goal_name);

                    try {
                        return ABTastyClickTracking(goal_name, null, trackingID);
                    } catch (except) {
                        window.debugLog(except);
                    }
                };

                _toConsumableArray(document.querySelectorAll('a[href^="tel:"]')).forEach(function (callBtn) {
                    callBtn.addEventListener('click', function () {
                        abTastyStepTracker('phone-call-click');
                    });
                });

                _toConsumableArray(document.querySelectorAll('#lm-navbar .lm-btn.lm-btn--icon.lm-btn--inline-flex.lm-btn--secondary, #navApplyNow')).forEach(function (applyBtn) {
                    applyBtn.addEventListener('click', function () {
                        abTastyStepTracker('apply-now-click');
                    });
                });

                _toConsumableArray(document.querySelectorAll('.lang-switcher-item.en, .spanish')).filter(function (langSwitcher) {
                    return langSwitcher.textContent === 'Español';
                }).forEach(function (espBtn) {
                    espBtn.addEventListener('click', function () {
                        abTastyStepTracker('espanol-click');
                    });
                });
            }
        })();
        break;

    default:
        window.debugLog('The page name "' + window.LM_CFG.page.name + '" doesn\'t have a case.');
        break;
}
